import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSend: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSend"><Path d="M14.0038 23.145L21.7733 2.22717L0.855469 9.99664L10.4179 13.5825L14.0038 23.145Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSend;
